<ng-container *ngIf="loading">
    <mapfre-loading></mapfre-loading>
</ng-container>
<ng-container *ngIf="!loading">
<div class="manage-twoFA">
    Manage two-factor authentication methods
</div>
<hr class="twoFA-hr margin-bottom mb24" [ngClass]="{'hr-18': isAcmic}">
<div class="okta-phone-change-success-notification" *ngIf="showSuccessNotification">
    <div class="okta-img-success-notification">
        <img src="./assets/img/images/okta-success-icon-check.png">
    </div>
    <div class="okta-success-text-container">
        <div class="okta-success-subcontainer">
            <div class="okta-success-text">
                <div class="okta-success-text-head">You're all set!</div>
                <div class="okta-success-text-info">Your phone number has been updated.</div>
            </div>
            <ng-container *ngIf="isAcmic else maIcon">
                <img src="./assets/img/images/okta-success-icon-close.png" (click)="onClose()" class="okta-close">
            </ng-container>
            <ng-template #maIcon>
                 <img src="./assets/img/images/okta-success-icon-close-acmic.svg" (click)="onClose()" class="okta-close">
            </ng-template>
        </div>
        
    </div>
</div>
<div class="manage-twoFA-email-container">
    <div class="manage-twoFA-email">
        Email
    </div>
    <div class="manage-twoFA-email-subContainer">
        <div class="manage-twoFA-mail">
            {{ oktaEmail }}
        </div>
        <div class="manage-twoFA-desc">
            Manage your email in <a href="" [routerLink]="['/profile', 'edit-contact']"
                class="manage-twoFA-desc-contact">contact details</a>.
        </div>
    </div>
</div>
<hr class="twoFA-hr" [ngClass]="{'twoFA-hr-mobile': isAcmic}">
<div class="manage-twoFA-phone-container">
    <div class="manage-twoFA-phone-subContainer">
        <div class="manage-twoFA-phone">
            <ng-container *ngIf="isAcmic; else maPhone">
                Phone number
            </ng-container>
            <ng-template #maPhone>
                Phone
            </ng-template>
            
        </div>
        <div class="manage-twoFA-contact">
            {{ phoneNumber }}
        </div>
    </div>
    <div class="w-100-mobile">
        <button (click)="editPhone()" class="twoFA-edit twoFA-edit-text">
            Edit
        </button>
    </div>
</div>
<hr class="twoFA-hr margin-bottom mb24" [ngClass]="{'twoFA-hr-mobile': isAcmic}">
<ng-container *ngIf="isAcmic else ma">
    <div class="manage-twoFA-back">
        <mapfre-button additionalClasses="link-button small red-link no-margin button-border-red twoFA-back"
            [backIcon]="'assets/img/images/okta-acmic-arrow-left.svg'" [iconClasses]="'align-middle'"
            [showIconsCustom]="true" [routerLink]="['/profile']">{{ "BACK" | translate }}
        </mapfre-button>
    </div>
</ng-container>
<ng-template #ma>
    <div class="manage-twoFA-back">
        <mapfre-button additionalClasses="link-button small red-link no-margin button-border-red twoFA-back"
            [backIcon]="'assets/img/images/icon-strong-arrow-left.svg'" [iconClasses]="'align-middle icon-strong-arrow-left'"
            [showIconsCustom]="true" [routerLink]="['/profile']">{{ "BACK" | translate }}
        </mapfre-button>
    </div>
</ng-template>
</ng-container>